import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/auth/authSlice";
import menuReducer from "./features/app/menu/menuSlice";
import alertReducer from "./features/app/alert/alertSlice";
import locationReducer from "./features/app/location/locationSlice";
import roleReducer from "./features/app/role/roleSlice";
import warehouseReducer from "./features/app/warehouse/warehouse.slice";
import userReducer from "./features/app/user/userSlice";
import farmerReducer from "./features/app/farmer/farmerSlice";
import vendorReducer from "./features/app/vendor/vendorSlice";
import reconcilationReducer from "./features/app/reconcilation/reconcilationSlice";
import procurementReducer from "./features/app/procurement/procurementSlice";
import chartReducer from "./features/app/charts/chartSlice";
import cropVarietyReducer from "./features/app/cropVariety/cropVarietySlice";
import productCategoryReducer from "./features/app/productCategory/productCategorySlice";
import processingFeeReducer from "./features/app/processingfee/vendorProcessFeeSlice";
import foProcurementReportReducer from "./features/app/foProcurementReport/foProcurementReportSlice";
import pageReducer from "./features/app/pagination/pageSlice";
import filterReducer from "./features/app/filters/filterSlice";
import internalFundTransferReportReducer from "./features/app/internalFundTransferReport/internalFundTransferReportSlice";
import logRequestResponseReportReducer from "./features/app/log/logRequestResponseSlice";
import remittanceReducer from "./features/app/remittance/vendorRemittanceSlice";
import voucherReducer from "./features/app/voucher/voucherSlice";
import stockReducer from "./features/app/stock/stockSlice";
import stopOrderReducer from "./features/app/stopOrder/stopOrderSlice";
import farmVisitReducer from "./features/app/farmVisit/farmVisitReportSlice";
import documentReducer from "./features/app/document/documentSlice";
//import agriReducer from "./features/app/agri/agriSlice";
import receiptAccountUpdationReducer from "./features/app/receiptAccountUpdation/receiptAccountUpdationSlice";
import ledgerEntryReducer from "./features/app/ledgerEntry/ledgerEntrySlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    menu: menuReducer,
    location: locationReducer,
    role: roleReducer,
    warehouse: warehouseReducer,
    user: userReducer,
    farmer: farmerReducer,
    reconcilation: reconcilationReducer,
    procurement: procurementReducer,
    chart: chartReducer,
    cropVariety: cropVarietyReducer,
    productCategory: productCategoryReducer,
    vendor: vendorReducer,
    processingfee: processingFeeReducer,
    foProcurementReport: foProcurementReportReducer,
    pageSlice: pageReducer,
    filterSlice: filterReducer,
    internalFundTransferReport: internalFundTransferReportReducer,
    logRequestResponseReport: logRequestResponseReportReducer,
    remittance: remittanceReducer,
    voucher: voucherReducer,
    stock: stockReducer,
    stoporder: stopOrderReducer,
    farmVisitReport: farmVisitReducer,
    document: documentReducer,
  //  agri: agriReducer,
    procurementAccountAudit: receiptAccountUpdationReducer,
    ledgerEntry: ledgerEntryReducer,
  },
});
